'use client';
import React, { useEffect, useRef } from 'react';
import Link from 'next/link';
import Container from '@/components/layout/Container';
import Image from 'next/image';
import Headings from '../../heading/Headings';
import BlazeSlider from 'blaze-slider';
import 'blaze-slider/dist/blaze.css';

const EcomWayfinder = ({ block, position, items }) => {
  const sliderInstance = useRef(null);
  const sliderRef = useRef(null);
  const { block_title, background_color_picker, _metadata } =
    block.ecom_wayfinder;

  useEffect(() => {
    const sliderConfig = {
      all: {
        slidesToShow: items.length,
        loop: false,
        transitionDuration: 400
      },
      '(max-width: 900px)': {
        slidesToShow: 2
      },
      '(max-width: 500px)': {
        slidesToShow: 1
      }
    };
    sliderInstance.current = new BlazeSlider(sliderRef.current, sliderConfig);

    return () => {
      sliderInstance.current.destroy();
      sliderInstance.current = null;
    };
  }, [items.length]);

  const EcomWayfinderItem = ({ item }) => {
    if (!item?.url) return null;

    return (
      <li>
        <Link
          href={item.url || '/'}
          prefetch={false}
          title={item.item_title}
          className="group text-default mb-2 block text-center group-hover:mb-1"
        >
          <div className="mb-0">
            <div className="relative mx-auto max-w-[274px]">
              <Image
                src={item.image.url}
                width="274"
                height="206"
                alt={item.item_title.replace(/\.[^/.]+$/, '')}
                sizes="(min-width: 1535px) 274px, (min-width: 1024px) 260px, 274px"
                className="bg-white transition delay-100 ease-in-out hover:opacity-60"
              />
            </div>
          </div>
          <div className="relative z-10 -mt-5 mb-4">
            <div className="relative z-10 -mt-5 mb-4 flex items-center justify-center">
              <h3 className="sh10 sm:preheading-r bg-crisp-white mx-auto inline-block px-4 py-2">
                {item.item_title.toUpperCase()}
              </h3>
            </div>
            <span className="txt-btn txt-btn-primary pb-1 duration-200">
              {item.link_label}
            </span>
          </div>
        </Link>
      </li>
    );
  };

  return (
    <section
      id={`${_metadata.uid}_${position}`}
      data-name={`ecom-wayfinder`}
      className={`bg-[${background_color_picker}] ecom-wayfinder standard-padding`}
    >
      <Container fullPage={false}>
        {block_title && (
          <Headings
            headingContent={block_title}
            headingClassName="h4 sm:h2 text-center px-4 max-w-xl mx-auto mb-[40px]"
          />
        )}
        <div className="mx-auto sm:max-w-[820px] lg:max-w-[886px] 2xl:max-w-[886px]">
          <div
            className={`blaze-slider relative flex flex-col`}
            ref={sliderRef}
          >
            <div className="blaze-container">
              <div className="blaze-track-container">
                <ul className="blaze-track">
                  {items.map((item, index) => (
                    <EcomWayfinderItem key={index} item={item} />
                  ))}
                </ul>
              </div>
            </div>
            <button className={`blaze-prev hidden`}>
              <span className="sr-only">previous slide</span>
            </button>
            <button className={`blaze-next hidden`}>
              <span className="sr-only">next slide</span>
            </button>
            <div
              className={`blaze-pagination indicators-dark justify-content absolute -bottom-7 flex w-full`}
            ></div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default EcomWayfinder;
